export const specificationData = [
  {
    id: "structure",
    icon: "🏗",
    title: "Structure",
    points: [
      { type: "text", text: "R.C.C. framed structure to with stand Wind & Seismic Loads. (ZONE-II)" },
      { type: "text", text: "RCC Framed Structure" }
    ]
  },

  {
    id: "walls",
    icon: "🧱",
    title: "Walls",
    points: [
      { type: "text", text: '8” thick Solid / Porotherm blocks for external walls' },
      { type: "text", text: '4” thick Solid / Porotherm blocks for internal walls' }
    ]
  },

  {
    id: "plastering",
    icon: "🛠",
    title: "Plastering",
    points: [
      { type: "sub", text: "Internal Walls" },
      { type: "text", text: "Plastering in CM (1:6)" },

      { type: "sub", text: "External Walls" },
      { type: "text", text: "1st coat: CM (1:6)" },
      { type: "text", text: "2nd coat: CM (1:4)" }
    ]
  },

  {
    id: "clubhouse_amenities",
    icon: "🏛️",
    title: "Clubhouse & Amenities",
    points: [
      { type: "text", text: "Well designed Club House with facilities like:" },
      { type: "text", text: "Multipurpose hall" },
      { type: "text", text: "Pre-function / holding area" },
      { type: "text", text: "Admin / utility office" },
      { type: "text", text: "Indoor games" },
      { type: "text", text: "Table tennis" },
      { type: "text", text: "Billiards lounge" },
      { type: "text", text: "Badminton court" },
      { type: "text", text: "Gym" },
      { type: "text", text: "Yoga / aerobics" },
      { type: "text", text: "Guest rooms (3 Nos)" },
      { type: "text", text: "Spa" },
      { type: "text", text: "Temperature pool @ club terrace" },
      { type: "text", text: "Party lawn @ club terrace" }
    ]
  },

  {
    id: "painting_cladding",
    icon: "🎨",
    title: "Painting / Cladding",
    points: [
      { type: "sub", text: "External" },
      { type: "text", text: "Cladding: Tiles / Marble / Soft marble stone or equivalent as per design" },
      { type: "text", text: "Paint Finish: Textured finish with top two coats of Exterior Emulsion" },
      { type: "text", text: "Aluminium Louvers as per design" },
      { type: "text", text: "Exterior grade HPL / equivalent as per design OR exterior grade premium paint as per design" },

      { type: "sub", text: "Internal Walls" },
      { type: "text", text: "Putty over punning / gypsum plastering finished with premium paint over primer" },

      { type: "sub", text: "Internal Ceiling" },
      { type: "text", text: "Only primer coat" },
      { type: "text", text: "False ceiling customer scope" },

      { type: "sub", text: "Utility / Laundry" },
      { type: "text", text: "Two coats exterior grade paint over primer" }
    ]
  },

  {
    id: "doors_windows_railings",
    icon: "🚪",
    title: "Doors, Windows & Railings",
    points: [
      { type: "sub", text: "Main Door" },
      {
        type: "text",
        text: "High-end hard wood door frame & shutter with veneer finish on both sides with PU coat, designer hardware & smart lock"
      },

      { type: "sub", text: "Internal Doors" },
      {
        type: "text",
        text: "High-end hard wood door frame & flush shutter with veneer finish both sides with PU coat, designer hardware"
      },

      { type: "sub", text: "French Doors (If any)" },
      {
        type: "text",
        text: "Aluminium frames with DGU glass panelled sliding shutters & hardware of reputed make"
      },

      { type: "sub", text: "Utility / Maid Room / Maid Toilet Doors" },
      {
        type: "text",
        text: "Veneer finish one side with PU coat and laminate on other side"
      },

      { type: "sub", text: "Windows" },
      {
        type: "text",
        text: "Aluminium frames with DGU toughened glass sliding/casement with designer hardware"
      },
      {
        type: "text",
        text: "Provision for mosquito track only (for sliding windows). Mosquito mesh extra cost"
      },

      { type: "sub", text: "Ventilators" },
      { type: "text", text: "Aluminium ventilators with premium hardware" },

      { type: "sub", text: "Railings" },
      { type: "text", text: "Aesthetically designed glass railing as per design" }
    ]
  },

  {
    id: "flooring",
    icon: "🪵",
    title: "Flooring",
    points: [
      { type: "sub", text: "Living Areas / Bedrooms / Common Spaces" },
      {
        type: "text",
        text: "Foyer/Drawing/Living/Dining/Lounge/Study/Pooja/Lobby/Bedrooms/Dress/Home Theatre: Imported Marble / Engineered Wooden / Glazed vitrified tiles + skirting as per design"
      },

      { type: "sub", text: "Master Bedroom / Walk-in closet" },
      { type: "text", text: "Imported marble flooring" },

      { type: "sub", text: "Toilets / Powder room" },
      { type: "text", text: "Tiles + skirting as per design" },

      { type: "sub", text: "Kitchen" },
      { type: "text", text: "Imported marble flooring + skirting as per design" },

      { type: "sub", text: "Maid room" },
      { type: "text", text: "Matt finish double charged vitrified tiles of reputed make" },

      { type: "sub", text: "Utility" },
      { type: "text", text: "Matt finish double charged vitrified tiles of reputed make" },

      { type: "sub", text: "Maid toilet" },
      { type: "text", text: "Glazed vitrified tiles of reputed make" },

      { type: "sub", text: "Store / Balcony" },
      { type: "text", text: "Matt finish double charged vitrified tiles of reputed make" },

      { type: "sub", text: "Deck area" },
      { type: "text", text: "WPC deck / tiles as per design" },

      { type: "sub", text: "Staircase" },
      { type: "text", text: "Imported marble flooring + skirting as per design" }
    ]
  },

  {
    id: "dadoing",
    icon: "🧼",
    title: "Dadoing",
    points: [
      { type: "sub", text: "Master toilet" },
      { type: "text", text: "Glazed vitrified tiles dadoing as per design" },

      { type: "sub", text: "Other toilets / Powder room" },
      { type: "text", text: "Glazed vitrified tiles dadoing as per design" },

      { type: "sub", text: "Wet kitchen / Utility" },
      { type: "text", text: "Wall cladding up to 3’ height with glazed vitrified tiles and exterior grade paint above" },

      { type: "sub", text: "Maid room toilet" },
      { type: "text", text: "Vitrified tile dado up to lintel height" }
    ]
  },

  {
    id: "kitchen",
    icon: "🍽",
    title: "Kitchen",
    points: [
      { type: "sub", text: "Countertop" },
      { type: "text", text: "No countertop (modular kitchen under customer scope)" },

      { type: "sub", text: "Water Provision" },
      { type: "text", text: "Separate municipal water tap (Manjeera/GHMC) along with borewell water" },

      { type: "sub", text: "Accessories provision" },
      { type: "text", text: "RO / water purifier point" },
      { type: "text", text: "Exhaust fan / chimney point" },
      { type: "text", text: "Drain pipe for refrigerator area" },
      { type: "text", text: "Provision for hot water near the sink" }
    ]
  },

  {
    id: "cp_sanitary",
    icon: "🚿",
    title: "CP & Sanitary Fixtures",
    points: [
      { type: "text", text: "Premium collection CP fittings of reputed make" },
      { type: "text", text: "Sanitary fixtures of reputed make" },
      { type: "text", text: "Shower cubicle with openable/sliding doors @ extra cost" },
      { type: "text", text: "Heat pump for hot water to all toilets & kitchen @ extra cost" }
    ]
  },

  {
    id: "electrical",
    icon: "⚡",
    title: "Electrical Fixtures",
    points: [
      { type: "text", text: "3-phase supply for each villa with individual meter boards" },
      { type: "text", text: "MCB for distribution boards of reputed make" },
      { type: "text", text: "Fire retardant low smoke wires of reputed make" },
      { type: "text", text: "Modular switches of reputed make" },
      { type: "text", text: "100% backup with DG sets" },

      { type: "sub", text: "Power plug points" },
      { type: "text", text: "Cooking range, chimney, refrigerator, microwave, mixer/grinder" },
      { type: "text", text: "Washing machine and dishwasher provision in utility area" },

      { type: "sub", text: "Metering" },
      { type: "text", text: "Both normal & DG power metered through energy meter" }
    ]
  },

  {
    id: "car_porch",
    icon: "🚗",
    title: "Car Porch",
    points: [
      { type: "text", text: "Cobble stone / concrete pavers / granite as per design" }
    ]
  },

  {
    id: "air_conditioning",
    icon: "❄",
    title: "Air Conditioning Works",
    points: [
      { type: "text", text: "Power provision in all rooms for AC units" },
      { type: "text", text: "Copper piping, AC units, VRV system with cassette completely client scope" }
    ]
  },



  {
    id: "telecom",
    icon: "📡",
    title: "Telecommunications, Cable TV & Internet",
    points: [
      { type: "text", text: "Telephone/Data points in all bedrooms, living area and home theatre" },
      { type: "text", text: "Intercom facility: 1 point in each bungalow (ground floor)" },
      { type: "text", text: "Cable TV provision in drawing/living, bedrooms and home theatre" },
      { type: "text", text: "FTTH internet provision" },
      { type: "text", text: "Video Door Phone (VDP) at main door" }
    ]
  },

  {
    id: "lifts",
    icon: "🛗",
    title: "Lifts",
    points: [
      { type: "text", text: "Elevator shaft will be provided as per architect design" },
      { type: "text", text: "Lift is client scope" }
    ]
  },

  {
    id: "wsp_stp",
    icon: "💧",
    title: "WSP & STP",
    points: [
      { type: "text", text: "Domestic water via exclusive water softening plant (Not RO)" },
      { type: "text", text: "Sewage treatment plant inside project; treated water used for landscaping" },
      { type: "text", text: "Rain water harvesting pits in each bungalow as per norms" },
      { type: "text", text: "Water meters for each unit for domestic & municipal water" }
    ]
  },

  {
    id: "ev_charging",
    icon: "🔌",
    title: "Charging Points For Electric Cars",
    points: [
      { type: "text", text: "Provision for charging point in each bungalow as per vendor specs (subject to govt guidelines)" }
    ]
  },





  /* ✅ Continue from 16 */
  {
    id: "security_bms",
    icon: "🛡️",
    title: "Security / BMS",
    points: [
      { type: "text", text: "Sophisticated round-the-clock security / surveillance system." },
      { type: "text", text: "Surveillance cameras at the main security, in open areas as per design and common areas to monitor." },
      { type: "text", text: "Solar power fencing around the boundary compound wall. Access control." },
      { type: "text", text: "Boom barriers as per design." }
    ]
  },

  {
    id: "centralized_billing",
    icon: "🧾",
    title: "Centralized Billing",
    points: [
      { type: "text", text: "Billing shall be done for consumption of electricity and water with prepaid meters system." }
    ]
  },

  {
    id: "centralized_water_supply",
    icon: "🚰",
    title: "Centralized Water Supply",
    points: [
      { type: "text", text: "Centralized underground sump will be provided for community. The water shall be then supplied to individual bungalows by means of hydro pneumatic system." }
    ]
  },

  {
    id: "main_landscaping_works",
    icon: "🌿",
    title: "Main Landscaping Works",
    points: [
      { type: "text", text: "Beautifully designed landscaping with exclusive footpath, activity areas." },
      { type: "text", text: "Children play area etc. is provided for the community." },
      { type: "text", text: "Multipurpose court" },
      { type: "text", text: "Cricket pitch" },
      { type: "text", text: "Kids play area" },
      { type: "text", text: "Outdoor fitness area" },
      { type: "text", text: "Amphitheatre with lawn mound" },
      { type: "text", text: "Senior citizens corner lawn" }
    ]
  },

  {
    id: "other_landscape_amenities",
    icon: "🏞️",
    title: "Other Landscape Amenities",
    points: [
      { type: "text", text: "Seaters" },
      { type: "text", text: "Interactive water feature" },
      { type: "text", text: "Sculpture" },
      { type: "text", text: "Seating pavilion" },
      { type: "text", text: "Dense planting" }
    ]
  },

  {
    id: "power_backup",
    icon: "🔋",
    title: "Power Backup",
    points: [
      { type: "text", text: "100% DG set backup with acoustic enclosure & AMF" }
    ]
  }


];
